var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVegetarianTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "75mm",
    height: "75mm",
    viewBox: "0 0 212.6 212.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.06,152.28a58,58,0,0,1-15.67-2.15C69.46,145,56.61,131.83,53,114.85,50.2,102.39,51.84,92.3,57.91,84.9c9.64-11.73,28.15-13.75,42-13.37,28.92.78,56.68-25.88,59.75-28.92l0,0a5.94,5.94,0,0,1,10.38,3.59c3.32,42.06-7.21,75.08-29.65,92.91a60.59,60.59,0,0,1-26.27,12.14A58,58,0,0,1,103.06,152.28Zm-6.24-74c-11.89,0-26.38,2.06-33.68,10.94-4.68,5.69-5.86,13.83-3.51,24.2,3.08,14.53,14.14,25.81,29.6,30.22a51.39,51.39,0,0,0,23.62.94,53.79,53.79,0,0,0,23.34-10.78c20.28-16.11,29.93-46.3,27.27-85.15h0l-.24-.06c-7.42,7.08-33.39,29.73-62,29.74l-1.46,0C98.77,78.27,97.8,78.26,96.82,78.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.32,71.12l-.74.78c-.26.24-.55.47-.82.7-.55.47-1.15.87-1.73,1.3-1.2.81-2.41,1.59-3.63,2.35-2.45,1.51-4.92,3-7.37,4.45-4.91,3-9.77,6-14.5,9.1a207.69,207.69,0,0,0-26.61,20.81,159.7,159.7,0,0,0-11.62,12c-1.85,2.05-3.57,4.21-5.31,6.34l-2.49,3.28c-.85,1.08-1.63,2.21-2.41,3.33A143,143,0,0,0,59.56,164v0A9.47,9.47,0,0,1,42,156.86a10.41,10.41,0,0,1,.57-1.16,159.47,159.47,0,0,1,21.52-29.13c1-1.11,2-2.21,3.1-3.25s2.11-2.12,3.18-3.16c2.18-2,4.34-4.08,6.61-6a170.87,170.87,0,0,1,14-10.89A214.48,214.48,0,0,1,121.19,85.7c5.21-2.52,10.48-4.85,15.76-7.1,2.64-1.13,5.28-2.24,7.9-3.39,1.3-.58,2.59-1.18,3.87-1.81.62-.35,1.27-.65,1.87-1l.9-.58Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegetarianTag);
export default __webpack_public_path__ + "static/media/VegetarianTag.be4d76fcb909025d76110f5300beeee3.svg";
export { ForwardRef as ReactComponent };